<div class="content">
  <div class="container-fluid">
    <div class="page-title">
      <h1>
        <a href="javascript:void(0);" (click)="goBack()" class="back" *ngIf="IsSuperAdmin">
          <i class="fa fa-arrow-left" aria-hidden="true"></i>
        </a>
        Account Management
      </h1>
      <div>
        <button pButton type="button" [disabled]="selectedRegion == null" label="Edit Member" icon="fa fa-plus" class="{{Confirm_button}} update"
        (click)="showAddCompanyMemberDialog(selectedRegionName, selectedRegionId, selectedParentRegionId)"></button>
        <button pButton type="button" label="Save" class="{{Confirm_button}}" (click)="saveAllAuthority()" [disabled]="saveButtonDisable"></button>
      </div>
    </div>
    <div class="page-filter clearfix multiple-filter" *ngIf="false">
      <div class="filter-flex">
        <div class="filter">
          <div class="filter-list name_title">
            <div class="filter-content">
              <p-select [options]="mspCompanyOptions" [(ngModel)]="defaultMspId" (onChange)="applyMspCompanyFilter();" [style]="{'width':'100%'}" placeholder="Company"></p-select>
            </div>
          </div>
        </div>
        <div class="filter search float-right">
          <div class="button">
            <input type="text" pInputText placeholder="Search" class="pInputText" [(ngModel)]="searchString" (ngModelChange)="applySearch()">
          </div>
        </div>
      </div>
    </div>
    <div class="page-content">
      <section>
        <div class="row">
          <div class="col-lg-2 col-sm-12">
            <div class="main-side">
              <h5 class="main-side-title" translate>Company</h5>
              <div class="content-list">
                <p-treeTable [value]="treeRegion" selectionMode="single" [(selection)]="selectedRegion" (onNodeSelect)="onNodeSelect($event)"
                (onNodeUnselect)="onNodeUnselect($event)" (selectionChange)="selectionChange()">
                  <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
                    <tr [ttSelectableRow]="rowNode">
                      <td style="width:160px" class="col-nowrap ellipsis">
                        <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                        <span title="{{rowData.RegionName}}">{{rowData.RegionName}}</span>
                      </td>
                      <!-- 減1是為了扣掉虛擬帳號 -->
                      <td style="width:60px"><span class="badge badge-pill badge-light">{{ rowData.Members ? (rowData.Members.length - 1) : 0 }}</span></td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr *ngIf="!pageLoading">
                      <td translate>No Data found</td>
                    </tr>
                    <ng-container *ngIf="pageLoading">
                      <tr *ngFor="let item of treeRegionGrid_Region">
                        <td>
                          <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 12, 'background-color': '#e9eef0'}"></p-skeleton>
                        </td>
                      </tr>
                    </ng-container>
                  </ng-template>
                </p-treeTable>
              </div>
            </div>
          </div>
          <div class="col-lg-10 col-sm-12">
            <div class="main-content">
              <div class="page-filter clearfix border-b-radius-none" style="margin: 0">
                <div class="page-title sub-title">
                  <h5 class="float-left color-black margin-none">{{selectedRegionName}}</h5>
                  <div class="filter-flex">
                    <div class="filter search float-right">
                      <div class="button">
                        <input type="text" pInputText placeholder="Search" class="pInputText" [(ngModel)]="searchString" (ngModelChange)="applySearch()">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="border-t-radius-none">
                <p-treeTable #tt [value]="authorityMgt_list" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,20]" [columns]="authorityMgt_cols">
                  <ng-template pTemplate="header" let-columns>
                    <tr>
                      <th style="width: 100px"></th>
                      <th *ngFor="let col of columns; let i = index" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
                        <ng-container *ngIf="i !== 3">
                          <div [ttSortableColumn]="col.field">
                            {{col.header | translate}}
                            <p-treeTableSortIcon [field]="col.field"></p-treeTableSortIcon>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="i === 3">
                          {{col.header | translate}}
                        </ng-container>
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns" let-i="rowIndex">
                    <tr>
                      <td class="col-nowrap text-center groupSetting" style="width: 100px; max-width: 100px">
                        <!-- <div class="center" *ngIf="rowData.rowType === 'Group'">
                          <a class="groupLink edit"><i class="fa fa-plus" aria-hidden="true" (click)="showAddAuthorityDailog(rowData)"></i></a>
                        </div>
                        <div class="center" *ngIf="rowData.rowType === 'children' && !rowData.IsRestrictEditing">
                          <a class="groupLink"><i class="fa fa-trash" aria-hidden="true" (click)="showDeleteConfirmDialog(rowData)"></i></a>
                        </div> -->
                        <span class="badge alert-warning opacity" *ngIf="rowData.rowType === 'Group' && rowData.isAccountMgt">{{'Account Manager' | translate}}</span>
                      </td>
                      <td>
                        <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                        <span *ngIf="rowData.rowType === 'Group'">{{rowData.label}}</span>
                      </td>
                      <td>{{rowData.company}}</td>
                      <!-- <td class="col-nowrap edit" style="width:200px" [ttEditableColumn]="rowData" [ttEditableColumnField]="'all'">
                        <p-treeTableCellEditor>
                          <ng-template pTemplate="output">
                            <p-checkbox binary="true" [ngModel]="rowData.all | strToBool : rowData" (onChange)="selectedAll($event, rowData)"  [disabled]="rowData.IsRestrictEditing"></p-checkbox>
                          </ng-template>
                          <ng-template pTemplate="input">
                            <p-checkbox binary="true" [ngModel]="rowData.all | strToBool : rowData" (onChange)="selectedAll($event, rowData)"  [disabled]="rowData.IsRestrictEditing"></p-checkbox>
                          </ng-template>
                        </p-treeTableCellEditor>
                      </td> -->
                      <td class="col-nowrap" style="width:300px">
                        <div class="flex flex-wrap" style="margin-left: -10px;" *ngIf="rowData.rowType === 'children'">
                          <div class="flex align gap-2">
                            <p-radioButton [name]="'authority_' + rowData.parentAcode + rowData.id" value="1" [inputId]="'authority_edit_' + rowData.parentAcode + '_' + rowData.id" [ngModel]="rowData.edit"
                          (ngModelChange)="selectedOther($event, rowData, 'edit')" [disabled]="rowData.isdisabled"></p-radioButton>
                            <label [attr.for]="'authority_edit_' + rowData.parentAcode + '_' + rowData.id" translate>Device Manager</label>
                          </div>
                           <div class="flex align gap-2">
                          <p-radioButton [name]="'authority_' + rowData.parentAcode + rowData.id" value="0" [inputId]="'authority_view_' + rowData.parentAcode + '_' + rowData.id" [ngModel]="rowData.edit"
                          (ngModelChange)="selectedOther($event, rowData, 'view')" [disabled]="rowData.isdisabled"></p-radioButton>
                            <label [attr.for]="'authority_view_' + rowData.parentAcode + '_' + rowData.id" translate>Viewer</label>
                          </div>
                          <div class="flex align gap-2">
                        <p-radioButton [name]="'authority_' + rowData.parentAcode + rowData.id" value="-1" [inputId]="'authority_none_' + rowData.parentAcode + '_' + rowData.id" [ngModel]="rowData.edit"
                          (ngModelChange)="showDeleteConfirmDialog(rowData)" [disabled]="rowData.isdisabled"></p-radioButton>
                            <label [attr.for]="'authority_none_' + rowData.parentAcode + '_' + rowData.id" translate>None</label>
                          </div>
                        </div>
                      </td>
                      <td class="col-nowrap edit" style="width:200px">
                        <!-- <td class="col-nowrap edit" style="width:200px" *ngIf="IsSuperAdmin || IsAdmin || (isMsp && this.currentUser.RegionId === mspMainRegionId)"> -->
                        <div class="flex flex-wrap checkbox gap-2" *ngIf="rowData.rowType === 'children'">
                          <div class="flex align gap-2">
                            <p-checkbox name="email" binary="true" label="{{'Weekly' | translate}}" [(ngModel)]="rowData.weekly" (ngModelChange)="onMailReportChange(rowData)" [disabled]="rowData.mailDisabled"></p-checkbox>
                              <label for="report" translate>Weekly</label>
                          </div>
                           <div class="flex align gap-2">
                              <p-checkbox name="email" binary="true" label="{{'Monthly' | translate}}" [(ngModel)]="rowData.monthly" (ngModelChange)="onMailReportChange(rowData)" [disabled]="rowData.mailDisabled"></p-checkbox>
                              <label for="report" translate>Monthly</label>
                          </div>
                        </div>
                      </td>
                      <!-- <td class="col-nowrap edit" style="width:200px" [ttEditableColumn]="rowData" [ttEditableColumnField]="'view'">
                        <p-treeTableCellEditor>
                          <ng-template pTemplate="output">
                            <p-checkbox binary="true" [ngModel]="rowData.view | strToBool : rowData" (onChange)="selectedOther($event, rowData, 'view')"  [disabled]="rowData.IsRestrictEditing"></p-checkbox>
                          </ng-template>
                          <ng-template pTemplate="input">
                            <p-checkbox binary="true" [ngModel]="rowData.view | strToBool : rowData" (onChange)="selectedOther($event, rowData, 'view')"  [disabled]="rowData.IsRestrictEditing"></p-checkbox>
                          </ng-template>
                        </p-treeTableCellEditor>
                      </td> -->
                      <!-- <td class="col-nowrap edit" style="width:100px" [ttEditableColumn]="rowData" [ttEditableColumnField]="'add'">
                        <p-treeTableCellEditor>
                          <ng-template pTemplate="output">
                            <p-checkbox binary="true" [ngModel]="rowData.add | strToBool : rowData" (onChange)="selectedOther($event, rowData, 'add')"  [disabled]="rowData.IsRestrictEditing"></p-checkbox>
                          </ng-template>
                          <ng-template pTemplate="input">
                            <p-checkbox binary="true" [ngModel]="rowData.add | strToBool : rowData" (onChange)="selectedOther($event, rowData, 'add')"  [disabled]="rowData.IsRestrictEditing"></p-checkbox>
                          </ng-template>
                        </p-treeTableCellEditor>
                      </td> -->
                      <!-- <td class="col-nowrap edit" style="width:200px" [ttEditableColumn]="rowData" [ttEditableColumnField]="'edit'">
                        <p-treeTableCellEditor>
                          <ng-template pTemplate="output">
                            <p-checkbox binary="true" [ngModel]="rowData.edit | strToBool : rowData" (onChange)="selectedOther($event, rowData, 'edit')"  [disabled]="rowData.IsRestrictEditing"></p-checkbox>
                          </ng-template>
                          <ng-template pTemplate="input">
                            <p-checkbox binary="true" [ngModel]="rowData.edit | strToBool : rowData" (onChange)="selectedOther($event, rowData, 'edit')"  [disabled]="rowData.IsRestrictEditing"></p-checkbox>
                          </ng-template>
                        </p-treeTableCellEditor>
                      </td> -->
                      <!-- <td class="col-nowrap edit" style="width:100px" [ttEditableColumn]="rowData" [ttEditableColumnField]="'delete'">
                        <p-treeTableCellEditor>
                          <ng-template pTemplate="output">
                            <p-checkbox binary="true" [ngModel]="rowData.delete | strToBool : rowData" (onChange)="selectedOther($event, rowData, 'delete')"  [disabled]="rowData.IsRestrictEditing"></p-checkbox>
                          </ng-template>
                          <ng-template pTemplate="input">
                            <p-checkbox binary="true" [ngModel]="rowData.delete | strToBool : rowData" (onChange)="selectedOther($event, rowData, 'delete')"  [disabled]="rowData.IsRestrictEditing"></p-checkbox>
                          </ng-template>
                        </p-treeTableCellEditor>
                      </td> -->
                      <!-- <td class="col-nowrap edit" style="width:100px" [ttEditableColumn]="rowData" [ttEditableColumnField]="'group'">
                        <p-treeTableCellEditor>
                          <ng-template pTemplate="output">
                            <p-checkbox binary="true" [ngModel]="rowData.group | strToBool : rowData" (onChange)="selectedOther($event, rowData, 'group')"  [disabled]="rowData.IsRestrictEditing"></p-checkbox>
                          </ng-template>
                          <ng-template pTemplate="input">
                            <p-checkbox binary="true" [ngModel]="rowData.group | strToBool : rowData" (onChange)="selectedOther($event, rowData, 'group')"  [disabled]="rowData.IsRestrictEditing"></p-checkbox>
                          </ng-template>
                        </p-treeTableCellEditor>
                      </td> -->
                      <!-- <td class="col-nowrap edit" style="width:100px" [ttEditableColumn]="rowData" [ttEditableColumnField]="'firmware'">
                        <p-treeTableCellEditor>
                          <ng-template pTemplate="output">
                            <p-checkbox binary="true" [ngModel]="rowData.firmware | strToBool : rowData" (onChange)="selectedOther($event, rowData, 'firmware')"  [disabled]="rowData.IsRestrictEditing"></p-checkbox>
                          </ng-template>
                          <ng-template pTemplate="input">
                            <p-checkbox binary="true" [ngModel]="rowData.firmware | strToBool : rowData" (onChange)="selectedOther($event, rowData, 'firmware')"  [disabled]="rowData.IsRestrictEditing"></p-checkbox>
                          </ng-template>
                        </p-treeTableCellEditor>
                      </td> -->
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                      <td translate [attr.colspan]="authorityMgt_cols.length + 1">No Data found</td>
                    </tr>
                </ng-template>
                </p-treeTable>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>

<!-- Add Authority -->
<p-dialog header="Add Authority" [(visible)]="displayAuthority" [modal]="true" [style]="{'width': '450px', 'min-width': '200px', 'top': '70px'}" [baseZIndex]="10000">
  <div class="dialog-content">
    <div class="form-group">
      <label>Comapany</label>
      <div class="select">
        <p-multiSelect [options]="addMspCompanyOptions" required [(ngModel)]="dialogInput.selectedCompany" [selectedItemsLabel]="'{0} ' + ('company selected' | translate)"></p-multiSelect>
      </div>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton (click)="saveAuthority()" label="Save" class="{{Confirm_button}}" [disabled]="dialogInput.selectedCompany.length === 0"></button>
    <button type="button" pButton (click)="displayAuthority = false" label="Cancel" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- Confirm 是否要刪除 Authority-->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="displayConfirmDialog" [modal]="true" [style]="{'width': '450px'}" [baseZIndex]="10000" class="ConfirmDialog">
  <div class="page-content-body">
    <p translate>Do you really want to delete this record?</p>
  </div>
  <ng-template #footer>
    <div class="page-content-btn">
      <button type="button" pButton label="{{'Confirm' | translate}}" class="{{Confirm_button}}" (click)="deleteAuthority()"></button>
      <button type="button" pButton (click)="displayConfirmDialog=false" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog>



<app-dialog (connectEvt)="controlCompanyMember($event);saveCompanyMember($event);"></app-dialog>
